import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _NewArrowRight;
var _excluded = ["className", "onScrollTop"];
import cn from "classnames";
import NewArrowRight from "@crehana/icons/NewArrowRight";
import { colors, transition } from "@crehana/ui";
import { scroll } from "@crehana/utils";
import { jsx as _jsx } from "react/jsx-runtime";
var white = colors.white;
var ScrollTopFAB = function ScrollTopFAB(_ref) {
  var className = _ref.className,
    onScrollTop = _ref.onScrollTop,
    other = _objectWithoutProperties(_ref, _excluded);
  var onClick = function onClick() {
    if (typeof onScrollTop === 'function') {
      onScrollTop();
    } else {
      scroll.scrollTop();
    }
  };
  return /*#__PURE__*/_jsx(_StyledButton, _objectSpread(_objectSpread({
    type: "button",
    className: cn('flex flex-shrink-0 items-center justify-center bg-secondary-main hover:bg-secondary-light w-32 h-32 rounded-full focus:outline-none', className),
    onClick: onClick
  }, other), {}, {
    $_css: transition('background-color'),
    children: _NewArrowRight || (_NewArrowRight = /*#__PURE__*/_jsx(NewArrowRight, {
      color: white,
      size: 16
    }))
  }));
};
export default ScrollTopFAB;
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-tpb00l-0"
})(["\n        transition: ", ";\n        & > svg {\n          transform: rotate(-90deg);\n        }\n      "], function (p) {
  return p.$_css;
});